import { MainMenu } from "@features/header/MainMenu"
import { MobileMenu } from "@features/header/MobileMenu"
import { useIsMobile } from "@hooks/useIsMobile"

export function MainMenuPanel() {
  const isMobile = useIsMobile(600)

  return <div data-mixpanel-area="Main Menu Panel">{isMobile ? <MobileMenu /> : <MainMenu />}</div>
}
